import Reveal from "@/components/Reveal";
import { STATS } from "@/data/site";

export default function StatsSection() {
  return (
    <section
      className="relative py-20 md:py-28 border-y border-white/10 bg-[#0a0a0a]"
      data-testid="stats-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
          {STATS.map((s, i) => (
            <Reveal
              key={s.label}
              delay={i * 0.06}
              className="border-l border-white/15 pl-6"
            >
              <div className="font-display text-5xl md:text-6xl font-black tracking-tighter leading-none text-[#FF4500]">
                {s.value}
              </div>
              <div className="text-sm md:text-base text-white/65 mt-3 max-w-[220px]">
                {s.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
